<template>
  <RepairStatus v-if="response?.code" :result="repair" />
  <div v-else class="container">
    <div class="checking-repair-status">
      <DefBreadCrumbs :result="breadcrumbs" />
      <div class="checking-repair-content">
        <DefTitle :result="1" :center="true">
          <h1>
            {{ messages.checkingRepairStatus }}
          </h1>
        </DefTitle>
        <form class="checking-repair-form" @submit.prevent="handlerSubmit">
          <DefInput
            :placeholder="messages.enterOrderNumber"
            :is-show-error="!!response?.error"
            :is-error="!!response?.error"
            name="repairNumber"
          >
            <span v-if="response?.error">
              {{ response?.error }}
            </span>
          </DefInput>
          <p v-if="screenWidth < 768" class="checking-repair-content__text">
            {{ messages.needMinimum5Symbols }}
          </p>
          <DefButtonPrimary type="submit" big>
            {{ messages.check }}
          </DefButtonPrimary>
        </form>
        <p v-if="screenWidth >= 768" class="checking-repair-content__text">
          {{ messages.needMinimum5Symbols }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import useScreenWidth from '@use/useScreenWidth';
import RepairStatus from '@components/Cabinet/Repair/RepairStatus/RepairStatus.vue';
import DefBreadCrumbs from '@components/Def/DefBreadCrumbs/DefBreadCrumbs.vue';
import DefTitle from '@components/Def/DefTitle/DefTitle.vue';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useStore } from '@store';

const screenWidth = useScreenWidth();
const { state, getters, dispatch, commit } = useStore();

const repair = computed(() => state?.repair?.data);
const breadcrumbs = computed(() => repair.value?.breadcrumbs);
const messages = computed(() => repair.value?.messages);
const response = computed(() => repair.value?.response);

const handlerSubmit = async ({ target }) => {
  await dispatch('repair/getStatusByNumber', new FormData(target));
};
</script>
<script>
export default {
  name: 'CheckingRepairStatus',
};
</script>

<style lang="scss" scoped>
.checking-repair-status {
}

.checking-repair-content {
  max-width: 638px;
  margin: 8px auto 64px;
  @include point-lg {
    margin: 24px auto 80px;
  }

  &__text {
    font-size: 14px;
    line-height: 125%;
    color: #5f5f67;
    //margin-top: 16px;
    margin-bottom: 16px;
    @include point-md {
      //margin-top: 0;
      margin-bottom: 0;
    }
  }
}

.checking-repair-form {
  display: grid;
  grid-template-columns: 1fr;
  @include point-md {
    grid-template-columns: 1fr 276px;
    grid-column-gap: 16px;
  }

  :deep {
    .def-input {
      height: unset;
      margin-bottom: 16px;
      @include point-md {
        margin-bottom: 10px;
      }

      .def-input__error {
        position: static;
        font-size: 12px;
      }
    }
  }
}
</style>
